<template>
  <div>
    <div class="d-flex justify-content-between align-self-center my-4">
      <span class="title">分配銷售員</span>
    </div>
    <AGCEditGroupInput
      v-model="inputVal.saleEmail"
      :inputType="'formTag'"
      :fieldName="'saleEmail'"
      label="銷售員帳戶"
      name="銷售員帳戶"
      placeholder="可輸入多個銷售員帳戶電郵，請按Enter 分隔銷售員帳戶電郵"
      :validate-reg-ex="regEx"
      :validate-fn="validateSaleEmail"
      rules=""
      :readOnly="readOnly"
    >
    </AGCEditGroupInput>
  </div>
</template>

<script>
import http from '@/helpers/http';
import AGCEditGroupInput from '../form/AGCEditGroupInput.vue';
import formMixin from '../../mixins/form';
import vModelMixin from '../../mixins/v-model';
import toastSettings from '../../helpers/toast-settings';

export default {
  mixins: [formMixin, vModelMixin],
  props: {
    readOnly: Boolean,
  },
  components: {
    AGCEditGroupInput,
  },
  data: () => ({
    regEx: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  }),
  watch: {
    'inputVal.saleEmail': async function (newSaleEmail, oldSaleEmail) {
      // Check newly added sale email
      if (oldSaleEmail && newSaleEmail.length > oldSaleEmail.length) {
        const payload = await http({
          method: 'POST',
          url: '/agc-admin-api/sales/checkSaleEmail',
          data: {
            email: newSaleEmail[newSaleEmail.length - 1],
          },
        }).toPromise();
        if (!payload.result) {
          this.$set(this.inputVal, 'saleEmail', this.inputVal.saleEmail.slice(0, -1));
          this.$bvToast.toast('銷售員帳戶電郵 無效', {
            ...toastSettings,
            title: '錯誤',
            toaster: 'b-toaster-top-center',
          });
        }
      }
    },
  },
  methods: {
    validateSaleEmail() {
      return true;
    },
  },
};
</script>
